import SuggestionsItem from './suggestion-item';
import './suggestions-item.less';

export default SuggestionsItem;